import { User } from "../@core/data/users";
import { ReceiptDetail } from "./receipt.model";

export class Product {
  id?: string;
  title?: string;
  description?: string;
  price?: number;
  wsPrice?: number;
  costPrice?: number;

  //Detail
  code?: string;
  barcode?: string;
  qrcode?: string;

  tags?: string[];
  coverUrl?: string;
  sourceType?: string; //video/images/document
  content?: string; //document
  videoUrl?: string; //video
  imagesUrl?: string[]; //images

  note1?: string;
  note2?: string;

  //Marketing
  expDate?: Date;
  isStock?: boolean;
  isService?: boolean;
  isFavorite?: boolean;
  isPopular?: boolean;
  isNew?: boolean;
  isSaleOff?: boolean;
  saleOffPrice?: number;
  stockMin?: number;
  stockMax?: number;
  //render
  warningStock?: boolean;
  warningStockMin?: number;
  warningStockMax?: number;

  //Advance
  unitId?: string;
  unitName?: string;
  groupId?: string;
  groupName?: string;
  categoryId?: string;
  categoryName?: string;
  supplierId?: string;
  supplierName?: string;
  producerId?: string;
  producerName?: string;
  originId?: string;
  originName?: string;
  sizeId?: string;
  sizeName?: string;
  colorId?: string;
  colorName?: string;

  //for search
  titleEn?: string;
  titleEns?: string[];
  matchings?: string[];
  matchIndex?: number;
  matchFilter?: boolean;

  //for Receipt-search-product
  receiptDetail?: ReceiptDetail;

  //warehouse
  receiveQuantity?: number;
  receiveAmount?: number;
  issueQuantity?: number;
  issueAmount?: number;
  balanceQuantity?: number;
  balanceAmount?: number;
  quantity?: number;

  //Schedule calculator balance
  isCalculatorBalance?: boolean;
  calculatorBalanceOn?: Date;

  //Initial
  initQuantity?: number;
  initAmount?: number;

  //Overview
  noCustomer?: number;
  saleQuantity?: number;
  saleAmount?: number;
  stockQuantity?: number;

  //render UI
  editing?: boolean;
  loading?: boolean;
  hadChange?: boolean;

  //data in offline
  fsId?: string;

  shopIdArchived?: string;
  isArchived?: boolean;
  archivedId?: string; //productId in archived shop
  isInitInventory?: boolean;
  initInventoryId?: string;
  initInventoryQuantity?: number;
  initInventoryDate?: Date;

  //default
  shopId?: string;
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  companyId?: string;
  isSynced?: boolean;
  syncedOn?: Date;
  syncedErr?: string;
}

export class Catalog {
  id?: string;
  mode?: string; //units /groups /categories /suppliers /producer /origin /size /color /groupFin /warehouses
  title?: string;
  description?: string;
  coverUrl?: string;
  tags?: string[];

  //render
  editing?: boolean;
  loading?: boolean;

  shopId?: string;
  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  companyId?: string;
}

export class ProductInventory {
  id?: string;
  type?: string; //INITIAL, RECEIVE, ISSUE
  receiptId?: string;
  purchaseId?: string;
  productId?: string;
  productCode?: string;
  productName?: string;
  productUnitName?: string;

  issueDate?: Date;
  issueDateSeconds?: number;
  issueDateMinutes?: number;
  issueDateHours?: number;
  issueDateDay?: number; //day of the month
  issueDateWeekDay?: number; //the day of the week, Sunday=0 - Saturday=6
  issueDateMonth?: number;
  issueDateYear?: number;

  isReceive?: boolean;
  code?: string;
  warehouseId?: string;
  comment?: string;

  receivePrice?: number;
  receiveQuantity?: number;
  receiveAmount?: number;

  issuePrice?: number;
  issueQuantity?: number;
  issueAmount?: number;

  //render
  balanceQuantity?: number;
  balanceAmount?: number;

  //trade
  isTrade?: boolean;
  supplierId?: string;
  supplierName?: string;
  customerId?: string;
  customerName?: string;

  //default
  shopId?: string;
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  companyId?: string;
}
